import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ua } from '@mssgme/helpers';
import { MESSENGERS } from '@mssgme/shared';
import { messengerIcons } from '@mssgme/ui';
import styles from './styles.scss';

export class MessengerButton extends React.Component {
    static propTypes = {
        platform: PropTypes.oneOf(MESSENGERS).isRequired,
        onClick: PropTypes.func,
        className: PropTypes.string,
    };

    handleClick = (e) => {
        const { onClick } = this.props;

        if (onClick) return onClick(e);

        if (ua.Android) {
            e.preventDefault();

            const { currentTarget } = e;
            const href = currentTarget.href;

            window.open(href);
        }
    };

    render() {
        const { platform, className, ...rest } = this.props;
        const Icon = messengerIcons[platform];

        return (
            <a
                className={classNames(styles.root, styles[platform], className)}
                target="_blank"
                rel="noopener noreferrer"
                {...rest}
                onClick={this.handleClick}
            >
                <Icon />
                <span />
            </a>
        );
    }
}
